import { FC } from 'react';

type SwitchType = {
  active: boolean;
  label: string;
  handleClick: () => void;
  disabled?: boolean;
};

const Switch: FC<SwitchType> = ({ active, handleClick, label, disabled }) => {
  return (
    <div>
      {label && (
        <label className= {disabled ? "block h-full mb-1 sm:text-[14px] text-[#666]" : "block h-full mb-1 sm:text-[14px] text-[#141414]"}>
          {label}
        </label>
      )}
      <div
        className={`
    w-11 h-6 flex items-center rounded-full p-1 transition-all
    ${active ? 'bg-[#333]' : 'bg-gray-300'}
    ${disabled ? 'opacity-50 pointer-events-none' : 'cursor-pointer'}
  `}
        onClick={() => handleClick()}
      >
        <div
          className={`bg-white h-5 w-5 rounded-full shadow-md transform transition-all
      ${active ? 'translate-x-4' : ''}
    `}
        ></div>
      </div>
    </div>
  );
};

export default Switch;
